import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'

const getDefaultStateForVendors = () => {
  return {
    users: [],
    data:{},
    roles:[],
    is_created:null,
    is_updated:null,
    is_deleted:null,
    filter:{
      keyword:"",
      active_only:"1"
    },
  }
}

// state
const state = getDefaultStateForVendors()

// getters
const getters = {
}

// mutations
const mutations = {
    SET_ROLES (state, data) {
      state.roles = data
    },
    RESET_STATE_FOR_VENDORS (state) {
      Object.assign(state, getDefaultStateForVendors())
    },
    QUICK_SEARCH(state, data){
        data.forEach(function (element) {
          element.email = (element.email != null && element.email != '') ? (element.email) : '-'
          element.mobile = (element.mobile != null && element.mobile != '') ? (element.mobile) : '-'
      });

      state.users = data
    },
    SET_FILTER(state, data)
    {
      state.filter = data
    },
    SET_IS_CREATED(state, data)
    {
      state.is_created = data
    },
    SET_IS_UPDATED(state, data)
    {
      state.is_updated = data
    },
    SET_IS_DELETED(state, data)
    {
      state.is_deleted = data
    },
    FETCH(state, data){
      if(data)
      {
        state.data = data
      }
    },

}

// actions
const actions = {
    resetState({ commit, dispatch }, payload) {
      commit("RESET_STATE_FOR_VENDORS")
    },
    quickSearch({ commit }, data) {
        return axios.post(apiRoutes['QUICK_SEARCH_USERS'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('QUICK_SEARCH', response.data.data)
                commit('SET_FILTER', data)
              } 
              else 
              {
                commit('QUICK_SEARCH', [])
                commit('SET_FILTER', data)
              }
            })
            .catch(error => {
              if (error.response) 
              {
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem submitting New Vendor", error);
              }
          });
    },
    fetch({ commit }, data) {
      return axios.post(apiRoutes['USER_RETRIEVE'], data, authHeader())
          .then(response => {
            if(response.data.code == 1)
            {
              commit('FETCH', response.data.data)
            } else {
              commit('FETCH', {})
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
    },
    async fetchRoles({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['LIST_ROLES'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                commit('SET_ROLES', response.data.data);
            }
            else
            {
                let errors = response.data.data.errors
                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")
                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_CREATED', 0);
            }

          })
          .catch((error) => {
              if (error.response) 
              {
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  alert("Problem Creating Vendor")
              }
          });
    },
    async create({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['CREATE_USER'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  let doc_number  = response.data.data.code
                  commit('SET_IS_CREATED', 1);
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: 'User (' + doc_number + ')' + " has been created!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
            }
            else
            {
                let errors = response.data.data.errors
                
                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")
                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_CREATED', 0);
            }

          })
          .catch((error) => {
              if (error.response) 
              {
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  alert("Problem Creating Vendor")
              }
          });
    },
    async update({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['UPDATE_USER'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  let doc_number  = response.data.data.code
                  commit('SET_IS_UPDATED', 1);
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: 'User (' + doc_number + ')' + " has been updated!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
            }
            else
            {
                let errors = response.data.data.errors
                commit('SET_IS_UPDATED', 0);

                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")

                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: msg,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
            }

          })
          .catch((error) => {
              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Problem Creating Vendor")
              }
          });
    },
    async delete({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['DELETE_VENDOR'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  let doc_number  = response.data.data.code
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: 'Vendor (' + doc_number + ')' + " has been deleted!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  commit('SET_IS_DELETED', 1);
            }
            else
            {
                let errors = response.data.data.errors

                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_DELETED', 0);
            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)
  
              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Problem Creating Vendor")
              }
          });
    },
}

export {
    state,
    getters,
    actions,
    mutations
}
